document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.before-after-slider').forEach(el => {
        new Slider(el, el.querySelector('[data-items]'), el.querySelector('[data-navigation-controls]'), el.querySelector('[data-nav]'), {
            count: 1,
            mouseDrag: true,
            count375: 1,
            count568: 1,
            count768: 1,
            count992: 1,
            count1200: 1,
            count1920: 1,
            gutter: 20,
            loop: false
        });
    });
});